import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Check } from 'lucide-react';
export function OfferSection() {
  return <section className="py-16 md:py-20 bg-white px-4" data-id="element-325">
      <div className="max-w-4xl mx-auto" data-id="element-326">
        <FadeInSection data-id="element-327">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-328">
            Esto es todo lo que obtienes hoy:
          </h2>

          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-329">
            <div className="w-full md:w-1/2" data-id="element-330">
              <img src="https://cdn.magicpatterns.com/uploads/iqbiJSaQZ9vhcPzXLQfyne/heylloyd-image-1772648876978.png" alt="El Código del Azúcar en Sangre eBook" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-331" />
            </div>

            <div className="w-full md:w-1/2 space-y-6" data-id="element-332">
              <div className="flex items-start" data-id="element-333">
                <Check className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-334" />
                <div data-id="element-335">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-336">
                    El eBook Principal Completo
                  </h3>
                  <p className="text-gray-600" data-id="element-337">
                    "El Código del Azúcar en Sangre: Domina tu Ansiedad y Apaga
                    el Hambre Incontrolable".
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-338">
                <Check className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-339" />
                <div data-id="element-340">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-341">
                    Acceso Inmediato
                  </h3>
                  <p className="text-gray-600" data-id="element-342">
                    Recibes el material en tu correo segundos después de tu
                    compra.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-343">
                <Check className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-344" />
                <div data-id="element-345">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-346">
                    Formato PDF Descargable
                  </h3>
                  <p className="text-gray-600" data-id="element-347">
                    Para que lo leas a tu propio ritmo, sin necesidad de
                    internet.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-348">
                <Check className="w-8 h-8 text-green-600 mr-4 flex-shrink-0" data-id="element-349" />
                <div data-id="element-350">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-351">
                    100% Compatible
                  </h3>
                  <p className="text-gray-600" data-id="element-352">
                    Léelo cómodamente en tu celular, tablet o computadora.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>;
}